import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';

function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center bg-surface px-4 py-20">
      <div className="text-center max-w-lg">
        <p className="text-brand-amber text-sm font-semibold uppercase tracking-[0.2em] mb-4">404</p>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Page <span className="text-gradient-brand">not found</span>
        </h1>
        <p className="text-gray-400 mb-8 leading-relaxed">
          That URL doesn&apos;t match anything on our site. Try the home page or contact us if you followed a
          broken link.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-brand px-6 py-3 text-sm font-bold text-black shadow-brand-glow hover:opacity-95"
          >
            <Home className="w-4 h-4" aria-hidden />
            Home
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold text-white hover:border-brand-amber/40 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" aria-hidden />
            Contact
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
